import 'reflect-metadata';
import { container } from 'tsyringe';
import { GetAllBanners } from './getAllBanners';
export const DependencyInjectionBannersInfrastructure = () => {
    container.register("iGetAllBanners", { useClass: GetAllBanners });
};
export default DependencyInjectionBannersInfrastructure;
